import { endpoints } from '../endpoints';
import { parseResponse } from '../parseResponse';
import { getHeader } from './generalApi';

export async function getCodedValueDomains(domainNamesList) {
  const nms = domainNamesList.domainNames.join('&domainNames=');
  return fetch(`${endpoints.codedValueDomain}/domainNames?domainNames=${nms}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function getCodedValueByDomainName(domainName) {
  return fetch(`${endpoints.codedValueDomain}/domainNames?domainNames=${domainName}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function getTADomainValues() {
  return fetch(`${endpoints.codedValueDomain}/taDomainValues`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}
